import { render, staticRenderFns } from "./skillsCompare.vue?vue&type=template&id=327254ce&scoped=true"
import script from "./skillsCompare.vue?vue&type=script&lang=js"
export * from "./skillsCompare.vue?vue&type=script&lang=js"
import style0 from "./skillsCompare.vue?vue&type=style&index=0&id=327254ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327254ce",
  null
  
)

export default component.exports